export const FLASH_MESSAGE = "FLASH_MESSAGE";

export function setFlashMessage(message, style, link = null) {
  return {
    type: FLASH_MESSAGE,
    payload: {
      message,
      style,
      link
    }
  };
}
